import React from 'react';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import cs from 'classnames'
import css from './index.css'
import Button from '~/components/common/Button';
import {modalClose, modalChange} from '~/modules/modal/actions';
import { userDispatcher } from '~/misc/userAccount'
import * as modes from '~/modules/modal/modes';
import {push as changeURL} from 'react-router-redux';


const pendingStatus = {
  'l2': "Your verification request is waiting for review by our CS team, we will notify you the result once it’s finished.",
  'loadsmartBook': "Your verification request is being reviewed by the Loadsmart team. We will book this load and notify you once it's approved.",
  'loadsmartBid': "Your verification request is being reviewed by the Loadsmart team, we will notify you the result once it’s finished.",
  'bid':"Your verification request is under review, you will be able to make an offer after it's approved.",
  'book': "Your verification request is under review, you will be able to book loads after it’s approved."
}

class Pending extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    const {closePop , context: { pendingType }} = this.props;
    return (
      <div className={css.popwrap}>
        <header className={css.title}>
          <p>Pending</p>
        </header>
        <main className={css.mainNormal}>
          {pendingStatus[pendingType]}
        </main>
        <footer className={css.footer}>
          <div className={css.footerRow}>
            <Button
              mods={['action']}
              onClick={closePop}
              className={css.button}
            >
              OK
            </Button>
          </div>
        </footer> 
      </div>
    )
  }
}

export default connect(null, mapDispatch({
  closePop: () => modalClose(modes.PENDING)
}))(Pending);


// WEBPACK FOOTER //
// ./src/components/Popup/Pending/index.js